import { useUsuarioEmpresaActiva } from "api/Usuario.hook"
import { useDispatch } from "hooks/useDispatch"
import { useSelector } from "hooks/useSelector"
import { Plus } from "react-feather"
import { useTranslation } from "react-i18next"
import {
  addEmptyContacto,
  empresaSelector,
} from "../../redux/slices/empresaSlice"
import FormContacto from "./FormContacto/index"

const Contacto = () => {
  const { t } = useTranslation()
  const { contactos } = useSelector(empresaSelector)
  const {
    activeCompany: { id },
  } = useUsuarioEmpresaActiva()

  const dispatch = useDispatch()

  const handleAddEmptyDireccion = () => dispatch(addEmptyContacto())

  return (
    <div className='w-full px-2'>
      {contactos?.map((contacto: $TSMigrationFixMe, i: $TSMigrationFixMe) => (
        <div
          key={contacto.id}
          className={`w-full my-4 ${i !== 0 ? "border-t-1 pt-2" : ""}`}
        >
          <FormContacto
            // @ts-expect-error TS(2322): Type '{ data: $TSFixMe; empresaId: string | undefined; ...
            data={contacto}
            empresaId={id}
            t={t}
          />
        </div>
      ))}

      <div className='justify-start w-full d-flex'>
        <span className='items-center justify-center underline text-gedesco pointer d-flex'>
          {" "}
          <Plus
            width={20}
            strokeWidth={3}
          />{" "}
          <span
            onClick={handleAddEmptyDireccion}
            className='ml-1 translate-y-1'
          >
            {t("perfilEmpresa.contact.addContact")}
          </span>
        </span>
      </div>
    </div>
  )
}

export default Contacto
